import {
  Pdf,
  Jpeg,
  Png,
  Unknown,
  Mp4,
  AI,
  Avi,
  Css,
  Eps,
  Gif,
  Doc,
  Docx,
  Indd,
  Ppt,
  Psd,
  Xls,
  Zip,
  Mp3,
  Mov,
  Wmv,
  Tiff,
  Wav,
  Txt,
  Otf,
  Ttf
} from 'components/Svg'

const renderExtension = name => {
  const lower = name.toLowerCase()

  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
    return Jpeg
  }
  if (lower.endsWith('.pdf')) {
    return Pdf
  }
  if (lower.endsWith('.png')) {
    return Png
  }
  if (lower.endsWith('.mp4')) {
    return Mp4
  }
  if (lower.endsWith('.ai')) {
    return AI
  }
  if (lower.endsWith('.avi')) {
    return Avi
  }
  if (lower.endsWith('.css')) {
    return Css
  }
  if (lower.endsWith('.eps')) {
    return Eps
  }
  if (lower.endsWith('.gif')) {
    return Gif
  }
  if (lower.endsWith('.doc')) {
    return Doc
  }
  if (lower.endsWith('.docx')) {
    return Docx
  }
  if (lower.endsWith('.indd')) {
    return Indd
  }
  if (lower.endsWith('.ppt')) {
    return Ppt
  }
  if (lower.endsWith('.pptx')) {
    return Ppt
  }
  if (lower.endsWith('.psd')) {
    return Psd
  }
  if (lower.endsWith('.xls')) {
    return Xls
  }
  if (lower.endsWith('.zip')) {
    return Zip
  }
  if (lower.endsWith('.mp3')) {
    return Mp3
  }
  if (lower.endsWith('.mov')) {
    return Mov
  }
  if (lower.endsWith('.wmv')) {
    return Wmv
  }
  if (lower.endsWith('.tiff')) {
    return Tiff
  }
  if (lower.endsWith('.wav')) {
    return Wav
  }
  if (lower.endsWith('.txt')) {
    return Txt
  }
  if (lower.endsWith('.otf')) {
    return Otf
  }
  if (lower.endsWith('.ttf')) {
    return Ttf
  }
  return Unknown
}

export default renderExtension



// WEBPACK FOOTER //
// ./src/components/Media/File/Thumbnail/renderExtension.js